import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OwnerDetail, OwnerType } from '../../interfaces/owner';

import { DataMappingService } from '../../services/data-mapping.service';
import { JsonDataService } from '../../services/json-data.service';
import { PetService } from '../../services/pet.service'
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

@Component({
  selector: 'app-owner-detail',
  templateUrl: './owner-detail.component.html',
  styleUrls: ['./owner-detail.component.scss']
})
export class OwnerDetailComponent implements OnInit {
  // modalRef: BsModalRef;
  selectedOwner: any;
  public ownerDetailForm: FormGroup;
  isLoading = false;
  ownerTypes: OwnerType[] = [];
  selectedOwnerType: any;
  isNew = false;
  ownerUpdateData = new FormData();
  isSavingOwner = false;
  public onClose= new Subject<boolean>();
  nationalityList: string[] = [];
  selectedNationality= '';
  referralList: string[] = [];
  selectedReferral= '';
  hasEditPermission: boolean = false;
  hasAddPermission: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {
    this.nationalityList = this.jsonDataService.jsonNationality;
    this.referralList = this.jsonDataService.jsonReferralSource;

    this.ownerDetailForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      phone: '',
      email: '',
      address: '',
      typeId: '',
      emergencyContact: '',
      nationality: '',
      vetDetails: '',
      howDidYouHearAboutGoodDog: '',
      howDidYouHearAboutGoodDogOther: '',
    });

    this.ownerDetailForm.get('howDidYouHearAboutGoodDog')?.valueChanges.subscribe(value => {
      console.log('howDidYouHearAboutGoodDog option changed:', value);
      this.selectedReferral = value;
    });
  }

  ngOnInit(): void {
    // Retrieve owner types
    this.getOwnerTypes();
    console.log(`OwnerDetailComponent, ngOnInit, This is owner detail modal`);
    console.log(`OwnerDetailComponent, ngOnInit, isNew: ${this.isNew}`);
    if (!this.isNew) {
      console.log(`OwnerDetailComponent, selectedOwner: ${JSON.stringify(this.selectedOwner)}`);
      this.selectedOwnerType = this.selectedOwner.type
      // const formData = this.dataMappingService()
      this.patchOwnerDetailForm(this.selectedOwner);

      this.hasEditPermission = this.petService.hasPermission('api.change_owner');
      console.log(`OwnerDetailComponent, hasEditPermission: ${this.hasEditPermission}`);
      // Disable form if user has no change owner permission
      this.disableForm();
    }
    else {
      this.hasAddPermission = this.petService.hasPermission('api.add_owner');
      console.log(`OwnerDetailComponent, hasAddPermission: ${this.hasAddPermission}`);
    }
  }

  patchOwnerDetailForm(owner: OwnerDetail) {
    this.ownerDetailForm.patchValue(owner);
    this.ownerDetailForm.controls['typeId'].setValue(owner.type.name);
    console.log(`OwnerDetailComponent, howDidYouHearAboutGoodDog: ${this.selectedOwner.howDidYouHearAboutGoodDog}`);
    this.ownerDetailForm.controls['howDidYouHearAboutGoodDog'].setValue(owner.howDidYouHearAboutGoodDog);
    // this.ownerDetailForm.patchValue({
    //   name: owner.first_name,
    //   phone: owner.phone,
    //   address: owner.address,
    //   email: owner.email,
    //   emergencyContact: owner.emergency_contact,
    //   nationality: owner.nationality,
    //   howDidYouHearAboutGoodDog: owner.how_did_you_hear_about_good_dog,
    //   howDidYouHearAboutGoodDogOther: owner.how_did_you_hear_about_good_dog_other,
    //   typeId: owner.type.name,
    // });
  } // end of patchOwnerDetailForm

  getOwnerTypes() {
    this.petService.getOwnerTypes().subscribe({
      next: (response) => {
        console.log(`getOwnerTypes, response: ${JSON.stringify(response)}`);
        this.ownerTypes = response;
      },
      error: (error) => {
        console.error(`getOwnerTypes, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getVaccines

  onSelectOwnerType (event: TypeaheadMatch): void{
    this.selectedOwnerType = event.item;
    console.log(`onSelectOwnerType, selectedOwnerType, name:${this.selectedOwnerType.name}, id:${this.selectedOwnerType.id}`);
  } // end of onSelectOwnerType

  saveOwner() {
    console.log(`saveOwner, isNew:${this.isNew}`);
    if(!this.isNew) {
      if (this.hasEditPermission){
        this.updateOwner();
      }
    } else {
      if (this.hasAddPermission){
        this.createOwner();
      }
    }
  } // end of saveOwner

  updateOwner() {
    this.isSavingOwner = true;
    this.createOwnerUpdatePayload();
    console.log(`updateOwner, ownerUpdateData:${this.ownerUpdateData}`);
    this.petService.updateOwner(this.selectedOwner.id, this.ownerUpdateData).subscribe({
      next: (response) => {
        this.isSavingOwner = false;
        console.log(`updateOwner, response: ${JSON.stringify(response)}`);
        this.hideModal();
        this.router.navigate(['owner']);
      },
      error: (error) => {
        this.isSavingOwner = false;
        console.error(`updateOwner, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingOwner = false;
  } // end of updateOwner

  createOwner() {
    this.isSavingOwner = true;
    this.createOwnerUpdatePayload();
    console.log(`createOwner, owner data:${JSON.stringify(this.ownerUpdateData)}`);
    this.petService.createOwner(this.ownerUpdateData).subscribe({
      next: (response) => {
        this.isSavingOwner = false;
        console.log(`createOwner, response: ${JSON.stringify(response)}`);
        this.hideModal()
      },
      error: (error) => {
        this.isSavingOwner = false;
        console.error(`createOwner, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingOwner = false;
  } // end of createOwner

  // createOwnerUpdatePayload() {

  // }

  // createOwnerUpdatePayload() {
  //   Object.keys(this.ownerDetailForm.controls).forEach(
  //     (key) => {
  //       this.ownerUpdateData.set(key, this.ownerDetailForm.controls[key].value);
  //     }
  //   );
  //   this.ownerUpdateData.set("typeId", this.selectedOwnerType.id);
  // }  // end of createOwnerUpdatePayload

  createOwnerUpdatePayload() {
    const formValues = this.ownerDetailForm.value;

    this.ownerUpdateData.append('first_name', formValues.firstName);
    this.ownerUpdateData.append('last_name', formValues.lastName);
    this.ownerUpdateData.append('phone', formValues.phone);
    this.ownerUpdateData.append('email', formValues.email);
    this.ownerUpdateData.append('address', formValues.address);
    this.ownerUpdateData.append('nationality', formValues.nationality);
    this.ownerUpdateData.append('emergency_contact', formValues.emergencyContact);
    this.ownerUpdateData.append('vet_details', formValues.vetDetails);
    this.ownerUpdateData.append('how_did_you_hear_about_good_dog', formValues.howDidYouHearAboutGoodDog);
    this.ownerUpdateData.append('how_did_you_hear_about_good_dog_other', formValues.howDidYouHearAboutGoodDogOther);
    this.ownerUpdateData.append("type_id", this.selectedOwnerType.id);
  }  // end of createOwnerUpdatePayload

  closeModal() {
    this.hideModal();
  } // end of closeModal

  hideModal() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  } // end of hideModal

  onSelectNationality (event: TypeaheadMatch): void{
    this.selectedNationality = event.item;
    console.log(`onSelectNationality, selectedNationality:${this.selectedNationality}`);
  } // end of onSelectNationality

  onSelectReferral (event: TypeaheadMatch): void{
    this.selectedReferral = event.item;
    console.log(`onSelectReferral, selectedReferral:${this.selectedReferral}`);
  } // end of onSelectReferral

  disableForm(){
    if (!this.hasEditPermission) {
      this.ownerDetailForm.disable(); 
    }
  }

  // onReferralChange(event: any) {
  //   this.selectedReferral = event.target.value;
  //   console.log(`onReferralChange, selectedReferral:${this.selectedReferral}`);
  // }
}
